import React, { useContext, useEffect, useMemo, useState } from 'react'
import TeamContext, { useTeam } from '../../data/team'
import { ReactComponent as PitchIcon } from '../../../../assets/icons/pitch.svg'
import { ReactComponent as BallIcon } from '../../../../assets/icons/ball.svg'
import dayjs from 'dayjs'
import styled from '@emotion/styled/macro'
import Loading from '../../../../components/Loading'
import Shield from '../../../../components/Shield'
import { useNavigate } from 'react-router'
import { startCase } from 'lodash'
import TeamCard from './TeamCard'
const FlexRow = styled('div')`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
`
const TeamResult = styled('h2')`
    text-align: center;
    background-color: var(--colors-grays-0);
    padding: 0.5rem;
    /* width: fit-content; */
    align-self: center;
    margin: 0.5rem auto;
    border-radius: var(--borderRadius-sm);
    border: var(--borders-main);
    text-shadow: var(--textBorder);
    cursor: pointer;
    transition: 0.4s ease all;
    &:hover {
        background: var(--colors-grays-40);
    }
    ${({ result }) => {
        if (result === 3) return 'color: var(--colors-success);'
        if (result === 0) return 'color: var(--colors-failure);'
        if (result === 1) return 'color: var(--colors-warning);'
    }}
`

const TeamGrid = styled('div')`
    width: 100%;
    display: grid;
    grid-gap: 1.5rem;
    grid-template-columns: 1fr 1fr;
`
const PlayedMatch = ({ match: _match, team, style, className, noLink }) => {
    const [{ activeTeam: _activeTeam, isLoading }] = useTeam()
    const activeTeam = team || _activeTeam
    const match =
        activeTeam?.eventStore?.[_match?._id] ||
        _match ||
        activeTeam?.eventStore?.[activeTeam?.previousMatch._id]
    const { officialResults, unofficialResults } = match || {}
    const results = officialResults || unofficialResults

    const {
        homeTeam = match.homeTeam,
        awayTeam = match.awayTeam,
        isActiveTeam,
    } = match?.teams?.reduce((acc, cv) => {
        if (cv.isHomeTeam) {
            const isActiveTeam = cv?.team?._id === activeTeam._id
            return { ...acc, homeTeam: cv, isActiveTeam }
        }
        return { awayTeam: cv, ...acc }
    }, {}) || {}
    const navigate = useNavigate()
    const { homeTeamScore, awayTeamScore } = useMemo(() => {
        if (officialResults) {
            return officialResults
        }
        if (match.logs) {
            let home = 0
            let away = 0
            match.logs.forEach((e) => {
                if (e.eventType === 'goalScored') {
                    return e?.team?.isHomeTeam ? ++home : ++away
                }
            })
            if (home || away) {
                return { homeTeamScore: home, awayTeamScore: away }
            }
            if (unofficialResults) {
                return unofficialResults
            }
            return {}
        }
    })
    const tableOutcome = useMemo(() => {
        if (homeTeamScore === awayTeamScore) {
            return { away: 1, home: 1 }
        }

        return homeTeamScore > awayTeamScore
            ? { home: 3, away: 0 }
            : { away: 3, home: 0 }
    }, [results])
    const teamResult = useMemo(
        () =>
            homeTeam && (!isActiveTeam ? tableOutcome.away : tableOutcome.home),
        [results]
    )
    if (isLoading) return <Loading />
    if (!match) return <strong></strong>

    return (
        <div style={style} className={className}>
            <h6
                style={{ margin: 0 }}
                onClick={() => !noLink && navigate('./events/' + match._id)}
            >
                {match.title ? match.title : startCase(match.eventType)}{' '}
                {!noLink && '↗️'} ️
            </h6>
            <small style={{ marginBottom: '0.025rem' }}>
                {dayjs(match.startTime).format('DD/MM/YYYY HH:mm')}
            </small>
            <TeamGrid>
                {homeTeam && (
                    <TeamCard team={homeTeam?.team || homeTeam}></TeamCard>
                )}
                {/* <BallIcon
                    height="1em"
                    width="1em"
                    style={{ flexShrink: 0 }}
                ></BallIcon> */}
                {awayTeam && (
                    <TeamCard team={awayTeam?.team || awayTeam}></TeamCard>
                )}
            </TeamGrid>
            {typeof homeTeamScore !== 'undefined' && (
                <TeamResult
                    result={teamResult}
                    onClick={() =>
                        !noLink && navigate('events/' + match._id + '/events')
                    }
                >
                    {homeTeamScore} - {awayTeamScore}
                </TeamResult>
            )}
        </div>
    )
}

export default PlayedMatch
